import { useEffect, useState } from "react";
import {
  Button, Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, Input, Stack, Textarea,
} from "@/components/ui";
import { useRenombrarFlujo } from "../../hooks/use-notificaciones";
import type { FlujoResumen } from "../../services/notificaciones-service";

/** Nombre y descripción del flujo (se guardan al momento, fuera del borrador). */
export function DatosFlujoDialog({ flujo, abierto, onCerrar }: { flujo: FlujoResumen; abierto: boolean; onCerrar: () => void }) {
  const [nombre, setNombre] = useState(flujo.nombre);
  const [descripcion, setDescripcion] = useState(flujo.descripcion ?? "");
  const renombrar = useRenombrarFlujo(flujo.id);

  useEffect(() => {
    if (abierto) {
      setNombre(flujo.nombre);
      setDescripcion(flujo.descripcion ?? "");
    }
  }, [abierto, flujo.nombre, flujo.descripcion]);

  const valido = nombre.trim().length > 0 && nombre.trim().length <= 150;

  return (
    <Dialog open={abierto} onOpenChange={(o) => (!o ? onCerrar() : undefined)}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Datos del flujo</DialogTitle>
        </DialogHeader>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (!valido) return;
            renombrar.mutate(
              { nombre: nombre.trim(), descripcion: descripcion.trim() || null },
              { onSuccess: onCerrar },
            );
          }}
        >
          <Stack gap="md">
            <Input label="Nombre" required maxLength={150} value={nombre} onChange={(e) => setNombre(e.target.value)} />
            <Textarea label="Descripción" maxLength={1000} rows={3} value={descripcion} onChange={(e) => setDescripcion(e.target.value)} />
          </Stack>
          <DialogFooter className="mt-6">
            <Button type="button" variant="default" onClick={onCerrar}>Cancelar</Button>
            <Button type="submit" disabled={!valido} loading={renombrar.isPending}>Guardar</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
